import React from 'react';
import classNames from 'classnames';

import styles from './Badge.module.scss';

type BadgeType = 'contained' | 'outlined';

export interface BadgeProps {
  className?: string;
  label: string;
  type?: BadgeType;
  color?: string;
}

export function Badge(props: BadgeProps) {
  const { className, label, type = 'contained', color } = props;

  const style = color
    ? type === 'contained'
      ? { backgroundColor: color, color: 'white' }
      : { borderColor: color, color }
    : {};

  return (
    <div
      className={classNames(styles.container, className, {
        [styles.outlined]: type === 'outlined'
      })}
      style={style}
    >
      {label}
    </div>
  );
}
